<div class="word-wrapper">
  <ejs-documenteditorcontainer [serviceUrl]="DOCUMENT_SERVICE_URL" (created)="documentCreated($event)" #wordDoc>
  </ejs-documenteditorcontainer>
  <!--    [enableToolbar]="true"-->
</div>
